import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import styled from '@emotion/styled';
import { __ } from '../helpers/TranslationService';

import { InfoFilledIcon } from './Icons/newIcons/InfoFilledIcon';
import { Modal } from './Modal';
import { softBlack } from '../consts/variables';

const StyledModal = styled(Modal)`
    .modalContent {
        max-width: 720px;
        text-align: left;
        padding: 36px;
        color: ${softBlack};
        width: 100%;

        & > .modalClose {
            top: 36px;
            right: 36px;
        }
    }
`;

const ModalTitle = styled.h3`
    font-size: 20px;
    margin-top: 0;
    margin-bottom: 0;
`;

const ModalBody = styled.p`
    margin-top: 24px;
    margin-bottom: 0;
`;

const LearnMoreButton = styled.button`
    text-decoration: underline;
    background: none;
    border: none;
    padding: 0;
`;

const LabelWrapper = styled.div``;

const Label = styled.p`
    color: ${softBlack};
    margin: 0;
    margin-right: 4px;
    display: inline;
`;

const StyledIcon = styled(InfoFilledIcon)`
    fill: ${(props) => props.theme.alert.succeed.icon};
    margin-right: 8px;
    flex-shrink: 0;
`;

const StyledInfo = styled.div`
    border: 2px solid ${(props) => props.theme.alert.succeed.border};
    background: ${(props) => props.theme.alert.succeed.background};
    color: ${(props) => props.theme.colors.gunmetal[100]};
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    padding: 16px;
    border-radius: ${({ theme }) => theme.container.borderRadius};
`;

export const GuaranteeCabinLabel = ({ className }: { className?: string }) => {
    const [showModal, setShowModal] = useState(false);

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleMoreInfoClick = (e: any) => {
        e.preventDefault();
        setShowModal(true);
    };

    return (
        <>
            <StyledInfo className={className}>
                <StyledIcon width={16} height={16} />
                <LabelWrapper>
                    <Label>{__('guaranteeCabin.label', 'dreamlines')}</Label>
                    <LearnMoreButton className="guaranteeCabin__link" onClick={handleMoreInfoClick}>
                        {__('learnMore', 'dreamlines')}
                    </LearnMoreButton>
                </LabelWrapper>
            </StyledInfo>

            {showModal &&
                createPortal(
                    <StyledModal isOpen={true} onClose={handleModalClose}>
                        <>
                            <ModalTitle>{__('guaranteeCabin.modalTitle', 'dreamlines')}</ModalTitle>
                            <ModalBody>{__('guaranteeCabin.modalBody', 'dreamlines')}</ModalBody>
                        </>
                    </StyledModal>,
                    document.body,
                )}
        </>
    );
};
